import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import { Modal } from 'react-bootstrap';

import { toast } from '@rickylandino/react-messages';

import { insertRadiologist } from '../../common/services/MaintenanceService';

export default function RadiologistModal(props) {
    const { register, handleSubmit, setValue, getValues,
        formState: { errors }, control } = useForm();

    const [modalInfo, setModalInfo] = useState({
        showModal: false,
        radiologistItem: {
            fName: '',
            lName: '',
            inactiveYN: false
        }
    });

    useEffect(() => {
        setModalInfo({
            ...modalInfo,
            showModal: true
        });
    }, []);

    function closeModal() {

        setModalInfo({
            showModal: false,
            radiologistItem: {
                fName: '',
                lName: '',
                inactiveYN: false
            }
        });
    }

    function handleUpdate() {
        var radiologistItem = modalInfo.radiologistItem;

        radiologistItem.inactiveYN = getValues().inactiveYN ? 1 : 0;
        radiologistItem.fName = getValues().fName;
        radiologistItem.lName = getValues().lName;
        radiologistItem.title = getValues().title;

        insertRadiologist(radiologistItem).then(data => {
            toast.success("Radiologist Added");

            if (props.from === 'manageFacility') {
                radiologistItem.radiologistID = data;
                setTimeout(() => {
                    props.hideModal(radiologistItem);
                }, 1000);
            }

            closeModal();
        })
    }

    return (
        <Modal size='lg' show={modalInfo.showModal} backdrop='static' onHide={closeModal}>
            <Modal.Header>
                <h1>Radiologist</h1>
            </Modal.Header>
            <Modal.Body>
                <div className="panel-content">
                    <div className="row">
                        <div className="form-group col-lg-6 col-12">
                            <label className="form-label">First Name</label>
                            <input className="form-control-custom" {...register("fName")} />
                        </div>

                        <div className="form-group col-lg-6 col-12">
                            <label className="form-label">Last Name</label>
                            <input className="form-control-custom" {...register("lName")} />
                        </div>

                        <div className="form-group col-lg-6 col-12">
                            <label className="form-label">Title</label>
                            <input className="form-control-custom" {...register("title")} />
                        </div>

                        <div className="form-group col-lg-6 col-12">
                            <label className="form-label">Set Inactive</label>
                            <div className="form-control-custom no-border">
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" className="custom-control-input" {...register("inactiveYN")} />
                                    <label className="custom-control-label"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row">
                    <div className="form-group col-12 padding-25-10">
                        <button className="btn btn-submit" onClick={handleUpdate}>Save</button>
                        <button className="btn btn-outline-default margin-left-15" id="closeModal" onClick={closeModal}>Cancel</button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}